module.exports = __webpack_public_path__ + "img/structuredapproach.3c5b6aa2.png";